<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">Copyright © 2021 L. Jon Wertheim</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="http://hmhbooks.com" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Names: Wertheim, L. Jon, author.</p>
<p class="center ">Title: Glory days : the summer of 1984 and the 90 days that changed sports and culture forever / L. Jon Wertheim.</p>
<p class="center ">Description: Boston : Houghton Mifflin Harcourt, 2021. | Includes bibliographical references and index.</p>
<p class="center ">Identifiers: LCCN 2020033845 (print) | LCCN 2020033846 (ebook) | ISBN 9781328637246 (hardcover) | ISBN 9780358449058 | ISBN 9780358449393 | ISBN 9781328637901 (ebook)</p>
<p class="center ">Subjects: LCSH: Sports—History—20th Century. | Nineteen eighty-four, A.D.</p>
<p class="center ">Classification: LCC GV576 .W45 2021 (print) | LCC GV576 (ebook) | DDC 796.09048—dc23</p>
<p class="center ">LC record available at <a href="https://lccn.loc.gov/2020033845" target="_blank">https://lccn.loc.gov/2020033845</a></p>
<p class="center ">LC ebook record available at <a href="https://lccn.loc.gov/2020033846" target="_blank">https://lccn.loc.gov/2020033846</a></p>
<p class="center spaceabove1">Cover design by Brian Moore</p>
<p class="center ">Cover photographs: © Bob Thomas Sports Photography / Getty Images
(Retton); © Andrew D. Bernstein / NBAE / Getty Images (Johnson / Bird);
© Heinz Kluetmeier / Sports Illustrated / Getty Images (Jordan); © Bruce
Bennett Studios / Getty Images (Gretzky); © Richard E. Aaron / Redferns /
Getty Images (Prince); © Richard McCaffrey / Michael Ochs Archive / Getty
Images (Springsteen)</p>
<p class="center ">Author photograph © John Filo</p>
<p class="center spaceabove1">v2.0721</p>
<p class="center spaceabove1">Part of the introduction was first published, in different form, as the 2014 article “Rare Air Time: Michael Jordan, the ’84 U.S. Olympic Trials and Me,” by Jon Wertheim for <em>Sports Illustrated</em> online.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?3b2d9367